import type { TActivity, TActivityType, TSession, TUserSession } from "@/types"

export const dashboardURL = "/"
export const peopleURL = "/people"
export const profileURL = "/profile"
export const coffeeCardsURL = "/coffee/cards"
export const companySettingsURL = "/company/settings"

export const buildUserURL = (userId: string) => `${peopleURL}/${userId}`

const activityToURL: Partial<Record<TActivityType, string>> = {
  anniversary: "/anniversaries",
  feedback: "/surveys/feedback",
  pulse: "/surveys/pulse",
  survey: "/surveys/survey",
  vacation: "/vacations",
  other: "/workshops",
  experience: "/workshops",
  onboarding: "/surveys/onboarding",
  party: "/parties",
  playbook: "/playbooks",
}

export const buildActivityURL = ({ type }: Pick<TActivity, "type">) => {
  return activityToURL[type] || `/${type}`
}

export const buildSessionURL = (ses: Pick<TSession, "id" | "type">, postfix?: "peers" | "summary" | "quiz") =>
  postfix ? `${buildActivityURL(ses)}/${ses.id}/${postfix}` : `${buildActivityURL(ses)}/${ses.id}`

// export const buildUserSessionURL = (usersessionId: string, postfix: "details" | "survey") =>
//   `/usersession/${usersessionId}/${postfix}`

export const buildUserSessionURL = ({ id, session }: Pick<TUserSession, "id" | "session">) =>
  `${buildSessionURL(session)}/us/${id}`

export const buildPeerReviewURL = (ses: Pick<TSession, "id" | "type">, peerId: string) =>
  `${buildSessionURL(ses, "peers")}/${peerId}`
